import { Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import Styles from "./ListingDetails.module.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { formatDateType } from "../../../../commons/FormatDate";
import { da } from "date-fns/locale";
import { useDispatch, useSelector } from "react-redux";
import { fetchListingTermsConfiguration } from "../../../../Redux/Slices/gnaAdminSlice";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import ViewFinalizeTerms from "../../ConGen/ViewFinalizeTerms/ViewFinalizeTerms";
import Charges from "../../ConGen/Charges/Charges";
import ViewConsent from "../../ConGen/ViewConsent/ViewConsent";
import ViewDoc from "../../ConGen/ViewDoc/ViewDoc";
import ScheduleModal from "../../Schedule/ScheduleModal";
import { fetchSchedule } from "../../../../Redux/Slices/scheduleSlice";
import { useLocation } from "react-router-dom";
import { fetchMatchmakingResults } from "../../../../Redux/Slices/bankingSlice";
import DiscomDetails from "./DiscomDetails";
import { openBilateralChat } from "../../Banking/CreateEdit/helpers";

const ListingDetails = ({ open, handleClose, data, type }) => {
  const bilateral = useSelector(
    (state) => state?.gnaAdminSlice?.fetchListingTermsConfiguration?.data?.page
  );
  const location = useLocation();
  const connectionId = location?.search?.split("=")[1];
  const bankingList = useSelector(
    (state) => state?.bankingSlice?.matchmakingData
  );

  const dispatch = useDispatch();
  useEffect(() => {
    if (type === "banking") {
      dispatch(
        fetchMatchmakingResults({ id: data?.id, statusFilter: "ONGOING" })
      );
    }
    if (data?.id && type !== "banking") {
      dispatch(
        fetchListingTermsConfiguration({
          id: data?.tenderNumber
            ? data?.capacityId || data?.generatorCapacityId
            : data?.id,
          userId: data?.userId,
          type: `${
            data?.consumerId
              ? `consumerId=${data?.consumerId}`
              : `generatorId=${data?.generatorId}`
          }`,
        })
      );
    }
  }, [data, dispatch]);

  const [connection, setConnection] = useState({});
  const [modals, setModals] = React.useState({
    terms: false,
    charges: false,
    consent: false,
    docs: false,
    schedule: false,
  });
  const toggleModal = (modalName, value) => {
    setModals((prev) => ({ ...prev, [modalName]: value }));
  };

  return (
    <>
      {modals.terms && (
        <ViewFinalizeTerms
          open={modals.terms}
          handleClose={() => toggleModal("terms", false)}
          data={connection}
        />
      )}

      {modals.charges && (
        <Charges
          open={modals.charges}
          onClose={() => toggleModal("charges", false)}
          contractId={connection?.id}
          userType={data?.consumerId ? "consumer" : "generator"}
        />
      )}

      {modals.consent && (
        <ViewConsent
          connectionId={connection.id}
          open={modals.consent}
          onClose={() => toggleModal("consent", false)}
          isAdmin={true}
        />
      )}

      {modals.docs && (
        <ViewDoc
          connectionId={connection.id}
          open={modals.docs}
          handleClose={() => toggleModal("docs", false)}
        />
      )}

      {modals.schedule && (
        <ScheduleModal
          connectionId={connection.id}
          open={modals.schedule}
          handleClose={() => toggleModal("schedule", false)}
        />
      )}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <div className={Styles.adminListingView}>
          <div
            className={`display_flex_row_gap_8_only ${Styles.listingTopDetails}`}
          >
            <ArrowBackIcon
              onClick={handleClose}
              style={{ cursor: "pointer" }}
            />

            {type === "banking" ? (
              <>
                <div className={Styles.listingTopDetailsContent}>
                  <div>Listing Number</div>
                  <div>{data?.name}</div>
                </div>
                <div className={Styles.listingTopDetailsContent}>
                  <div>Banking Factor (%)</div>
                  <div>{data?.bankingFactor}</div>
                </div>
                <div className={Styles.listingTopDetailsContent}>
                  <div>Settlement Rate (₹/kWh)</div>
                  <div>{data?.settlementRate}</div>
                </div>
                <div className={Styles.listingTopDetailsContent}>
                  <div>Expires on</div>
                  <div>{data?.expiryAt}</div>
                </div>
              </>
            ) : data?.tenderNumber ? (
              <>
                <div className={Styles.listingTopDetailsContent}>
                  <div>Tender Number</div>
                  <div>{data?.tenderNumber}</div>
                </div>
                {data?.auctionNumber && (
                  <div className={Styles.listingTopDetailsContent}>
                    <div>Auction Number</div>
                    <div>{data?.auctionNumber}</div>
                  </div>
                )}
                <div className={Styles.listingTopDetailsContent}>
                  <div>Tender Start Date and Time</div>
                  <div>{data?.tenderStartDateTime}</div>
                </div>
                <div className={Styles.listingTopDetailsContent}>
                  <div>Tender End Date and Time</div>
                  <div>{data?.tenderCloseDateTime}</div>
                </div>
              </>
            ) : (
              <>
                <div className={Styles.listingTopDetailsContent}>
                  <div>Listing Number</div>
                  <div>{data?.name}</div>
                </div>
                <div className={Styles.listingTopDetailsContent}>
                  <div>Energy Type</div>
                  <div>{data?.energyFuelType}</div>
                </div>
                <div className={Styles.listingTopDetailsContent}>
                  <div>Voltage</div>
                  <div>{data?.voltageLevel}</div>
                </div>
                <div className={Styles.listingTopDetailsContent}>
                  <div>Listing Exp. Date and Time</div>
                  <div>
                    {formatDateType(data?.listingExpDate)}:{" "}
                    {data?.listingExpTime}
                  </div>
                </div>
                <div className={Styles.listingTopDetailsContent}>
                  <div>Terms Exp. Date and Time</div>
                  <div>
                    {formatDateType(data?.termsExpDate)}: {data?.termsExpTime}
                  </div>
                </div>
              </>
            )}
            <div className={Styles.listingTopDetailsContent}>
              <div>Status</div>
              <div className={Styles.tenderStatus}>
                {data?.status || data?.tenderStatus}
              </div>
            </div>
          </div>
          {type !== "banking" && (
            <div
              className={`display_flex_row tableHeading ${Styles.listingTableHeader}`}
            >
              <div style={{ width: "20%" }} className="table_text_align_left">
                Self Requisition
              </div>
              <div style={{ width: "20%" }}>Quantity</div>
              <div style={{ width: "20%" }}>Energy Rate</div>
              <div style={{ width: "20%" }}>Date Range</div>
              <div style={{ width: "20%" }}>Time Range</div>
            </div>
          )}
          <div className={`scroll_bar_y ${Styles.listingTableBody}`}>
            {type === "banking" ? (
              <>
                {bankingList?.matches?.map((ele) => (
                  <DiscomDetails ele={ele} />
                ))}
              </>
            ) : (
              <>
                {bilateral?.map((ele, index) => (
                  <div className={`${Styles.listingDetailsCont}`}>
                    <div
                      className={`display_flex_row tableDetails ${Styles.listingTopContainer}`}
                    >
                      <div
                        style={{ width: "20%" }}
                        className="table_text_align_left"
                      >
                        <div
                          className={`display_flex_column_gap_4 ${Styles.containerHeaderDetails}`}
                        >
                          <div>
                            {data?.consumerId
                              ? ele?.capacityGenerator?.generatorName
                              : ele?.capacityConsumer?.consumerName}
                          </div>
                          <div>
                            {data?.consumerId
                              ? ele?.capacityGenerator?.name
                              : ele?.capacityConsumer?.name}
                          </div>
                        </div>
                      </div>
                      <div style={{ width: "20%" }}></div>
                    </div>
                    {ele?.bilateralConnections?.map((element, idx) => (
                      <div className={`display_flex_row tableDetails`}>
                        <div
                          style={{ width: "20%" }}
                          className="table_text_align_left"
                        >
                          Connection {idx + 1}
                        </div>
                        <div style={{ width: "20%" }}>
                          {element?.quantity}(MW)
                        </div>
                        <div style={{ width: "20%" }}>
                          {element?.energyRateType === "FIXED"
                            ? element?.amount
                            : element?.energyRateType === "DAM_PLUS"
                            ? `DAM+${element?.amount}`
                            : `DAM-${element?.amount}`}{" "}
                          (₹/kWh)
                        </div>
                        <div style={{ width: "20%" }}>
                          {formatDateType(element?.dateStartAt)} to{" "}
                          {formatDateType(element?.dateEndAt)}
                        </div>
                        <div style={{ width: "20%" }}>
                          {element?.slotStartAt?.split(":")?.[0]}:
                          {element?.slotStartAt?.split(":")?.[1]} to{" "}
                          {element?.slotEndAt === "23:59:00"
                            ? "24:00"
                            : `${element?.slotEndAt?.split(":")?.[0]} : ${
                                element?.slotEndAt?.split(":")?.[1]
                              }`}
                        </div>
                      </div>
                    ))}
                    <div
                      className={`display_flex_row_gap_8_only ${Styles.listingButtomDetails}`}
                    >
                      <div
                        onClick={() => {
                          toggleModal("terms", true);
                          setConnection(ele);
                        }}
                      >
                        <span>View Terms</span>
                        <ArrowOutwardIcon
                          style={{ fontSize: "10px", marginTop: "-10px" }}
                        />
                      </div>
                      <div
                        onClick={() => {
                          toggleModal("charges", true);
                          setConnection(ele);
                        }}
                      >
                        View Charges
                        <ArrowOutwardIcon
                          style={{ fontSize: "10px", marginTop: "-10px" }}
                        />
                      </div>
                      <div
                        onClick={() => {
                          toggleModal("docs", true);
                          setConnection(ele);
                        }}
                      >
                        View Docs{" "}
                        <ArrowOutwardIcon
                          style={{ fontSize: "10px", marginTop: "-10px" }}
                        />
                      </div>
                      <div
                        onClick={() => {
                          toggleModal("consent", true);
                          setConnection(ele);
                        }}
                      >
                        View Consent{" "}
                        <ArrowOutwardIcon
                          style={{ fontSize: "10px", marginTop: "-10px" }}
                        />
                      </div>
                      <div
                        onClick={() => {
                          toggleModal("schedule", true);
                          setConnection(ele);
                          dispatch(fetchSchedule(ele?.id));
                        }}
                      >
                        View Schedule{" "}
                        <ArrowOutwardIcon
                          style={{ fontSize: "10px", marginTop: "-10px" }}
                        />
                      </div>
                      <div
                        onClick={() =>
                          openBilateralChat(dispatch, {
                            header: data?.generatorId
                              ? ele?.capacityGenerator?.name
                              : ele?.capacityConsumer?.name,
                            fromUser: data?.consumerId
                              ? ele?.capacityGenerator?.name
                              : ele?.capacityConsumer?.name,
                            toUser: data?.generatorId
                              ? ele?.capacityGenerator?.name
                              : ele?.capacityConsumer?.name,
                            hidechat: true,
                          })
                        }
                      >
                        View Chat
                      </div>
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ListingDetails;
